import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { UserDataResponse } from './user-management.service';
import { HttpRetryableService } from './http-retryable.service';

export interface BikCheckResult {
  success: boolean;
  data?: BikCheck;
  error?: string;
}

export interface RsCheckResult {
  success: boolean;
  error?: string;
  error_description: string;
}

export interface BankingAccountCheckDataDto {
  rs: string;
  bik: string;
  type: string;
}

export interface BankingInformationResult {
  success: boolean;
  error?: string;
  data?: BankingInformationDto[];
}

export interface SaveBankingInformationReq {
  details: BankingInformationDto[];
}

export interface BankingInformationDto {
  id?: string;
  inn?: number;
  kpp?: string;
  bik?: string;
  rs?: string;
  ks?: string;
  name?: string;
  logoUrl?: string | null;
  isMain?: boolean;
}

export interface BikCheck {
  inn?: number;
  kpp?: string;
  bik?: string;
  ks?: string;
  name?: string;
  rs?: string;
  logoUrl?: string | null;
}

export interface BankAccountCheckResponse {
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PersonalService {
  private readonly baseRestURL: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly httpRetryable: HttpRetryableService,
    config: ConfigService
  ) {
    this.baseRestURL = config.baseRestURL;
  }

  public checkBankAccount(
    checkData: BankingAccountCheckDataDto
  ): Observable<RsCheckResult> {
    const curUrl = `${this.baseRestURL}personal/validate/rs`;
    return this.http.post<RsCheckResult>(curUrl, checkData);
  }

  public checkBik(bik: string): Observable<BikCheckResult> {
    const curUrl = `${this.baseRestURL}personal/bankInfo`;
    const params = new HttpParams().set('bankId', bik);
    return this.http.get<BikCheckResult>(curUrl, { params });
  }

  public getUserData() {
    return this.httpRetryable.get<UserDataResponse>(
      `${this.baseRestURL}personal/main`
    );
  }

  public loadBankingData(): Observable<BankingInformationResult> {
    const curUrl = `${this.baseRestURL}personal/bank_details`;
    return this.httpRetryable.get<BankingInformationResult>(curUrl);
  }

  public postBankDetails(bankData: SaveBankingInformationReq): Observable<{
    success: boolean;
    error?: string;
    error_description?: string;
  }> {
    const curUrl = `${this.baseRestURL}personal/bank_details`;
    return this.httpRetryable.post<{ success: true }>(curUrl, bankData);
  }
}
